import { Injectable } from '@angular/core';
import { Http, L10n, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { CommunityTransactionForSaleQuery, CommunityTransactionForSaleQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root' })
@QueryHandlerFor(CommunityTransactionForSaleQuery)
@Wrapper(CommunityTransactionForSaleQueryHandlerBase)
export class CommunityTransactionForSaleQueryHandler {
    public constructor(
        http: Http,
        L10n: L10n
    ) { }
}
